import styles from "../../pages/Home/styles.module.sass";
import { FaMapMarkerAlt } from "react-icons/fa";
import { AiFillCamera, AiFillDatabase } from "react-icons/ai";
import { MdWallpaper } from "react-icons/md";
import { Link } from "react-router-dom";
import { ImVideoCamera } from "react-icons/im";
import { getPropertyUrl } from "../../utils/filter-transforms";
import cn from "classnames";
import format from "date-fns/format";
import ActionButton from "../../components/ActionButton";
import InfoBox from "../../components/InfoBox";

export function createPropertyColumns(
  columnHelper,
  navigate,
  handleVideoClick,
  approvedPics
) {
  return [
    columnHelper.accessor("property_code", {
      header: "",
      cell: ({ row: { original: property } }) => (
        <a
          className={styles.introCell}
          href={getPropertyUrl(property)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div>Šifra: {property?.property_code}</div>
          <div>Tip: {property?.type}</div>
        </a>
      ),
    }),

    columnHelper.accessor("location", {
      header: "",
      cell: ({ row: { original: property } }) => (
        <div className={styles.location}>
          <div>
            <FaMapMarkerAlt />
            {property?.city?.name || property?.city}, {property?.area}
          </div>
          <div className={styles.locationSmall}>
            <div className={styles.box}>{property?.property_size}m2</div>
            <div className={cn(styles.box, styles.price)}>
              {property?.price}€
            </div>
          </div>
        </div>
      ),
    }),

    columnHelper.accessor("owner", {
      header: "",
      cell: () => <div className={styles.owner}>Vlasnik: /</div>,
    }),

    columnHelper.accessor("created", {
      header: "",
      cell: ({ row: { original: property } }) => (
        <div className={styles.created}>
          <div>Vreme dodavanja nekretnine:</div>
          {property?.date && (
            <div>{format(new Date(property.date), "yyyy-MM-dd HH:mm:ss")}</div>
          )}
          <InfoBox label="Ugovor" active={property?.contract} styles={styles} />
          <InfoBox
            label="Odobrena"
            active={property?.publish}
            styles={styles}
          />
        </div>
      ),
    }),

    columnHelper.accessor("operations", {
      header: "",
      cell: ({ row: { original: property } }) => (
        <div className={styles.actionsContainer}>
          <ActionButton
            icon={AiFillCamera}
            label="Slike"
            styles={styles}
            className={cn(styles.iconButton, {
              [styles.green]:
                property?.pictures && approvedPics(property.pictures),
              [styles.red]:
                property?.pictures?.length > 0 &&
                !approvedPics(property.pictures),
            })}
            onClick={() =>
              property?.id && navigate(`/property/pictures/${property.id}`)
            }
          />
          <ActionButton
            icon={MdWallpaper}
            label="Skica"
            styles={styles}
            className={cn(styles.iconButton, {
              [styles.green]: property?.scheme?.path || property?.scheme,
            })}
            onClick={() =>
              property?.id && navigate(`/property/schema/${property.id}`)
            }
          />
          <Link
            className={styles.actionItem}
            to={property?.id ? `/properties/edit/${property.id}` : "#"}
          >
            <button className={styles.iconButton}>
              <AiFillDatabase />
              {property?.active_tasks > 0 && (
                <div className={styles.absoluteCircle}>
                  {property.active_tasks}
                </div>
              )}
            </button>
            <div className={styles.text}>Podaci</div>
          </Link>
          <ActionButton
            icon={ImVideoCamera}
            label="Video"
            styles={styles}
            className={cn(styles.iconButton, {
              [styles.green]: property?.video,
            })}
            onClick={() => handleVideoClick(property)}
          />
        </div>
      ),
    }),
  ];
}
